export default __webpack_public_path__ + "static/adrian-18856f4083d1ba30533f0c2c8052028c.png";